<script setup></script>

<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.00012207" width="12" height="12" rx="3" fill="currentColor" />
  </svg>
</template>
